import type { MRT_TableInstance } from "mantine-react-table-open";

function isColumnComplete<TData extends Record<string, unknown>>(
  table: MRT_TableInstance<TData>,
  columnId: keyof TData | undefined
) {
  if (!columnId) {
    return true;
  }

  const rows = table.getRowModel().rows;
  if (rows.length === 0 || table.getState().isLoading === true) {
    return true;
  }

  return !rows.some((row) => {
    const item = row.original;
    return item[columnId] === null || item[columnId] === undefined;
  });
}

export default isColumnComplete;
